const state = {
    token: null,
    title: "",
    toggleShow: true,
    backShow: true,
    mobile: null,
    sendList: [],
    acceptList: [],
    dict: {},
    mapTitle: '',
};
export default state;
